import { z } from "zod";

/**
 * Mirrors backend internal/identity/adminrecovery handler's
 * adminListPendingResponse and approveResponse shapes.
 */

export const pendingRequestSchema = z.object({
  id: z.string(),
  user_id: z.string(),
  requesting_email: z.string().optional(),
  requesting_ip: z.string().optional(),
  request_reason: z.string().optional(),
  created_at: z.string(),
});
export type PendingRequest = z.infer<typeof pendingRequestSchema>;

export const pendingListResponseSchema = z.object({
  items: z.array(pendingRequestSchema),
});
export type PendingListResponse = z.infer<typeof pendingListResponseSchema>;

/**
 * Mirrors the backend adminRecoveryDecidedSummary — the
 * read-only decided/history projection. omitempty fields on the
 * wire are optional here. decided_by_admin_id is the raw
 * operator UUID (name-resolution is a backend follow-up).
 */
export const decidedRequestSchema = z.object({
  id: z.string(),
  user_id: z.string(),
  requesting_email: z.string().optional(),
  request_reason: z.string().optional(),
  created_at: z.string(),
  state: z.string(),
  decided_at: z.string().optional(),
  decision_reason: z.string().optional(),
  consumed: z.boolean(),
  decided_by_admin_id: z.string().optional(),
});
export type DecidedRequest = z.infer<typeof decidedRequestSchema>;

export const decidedListResponseSchema = z.object({
  items: z.array(decidedRequestSchema),
});
export type DecidedListResponse = z.infer<typeof decidedListResponseSchema>;

export const approveResponseSchema = z.object({
  ticket: z.string(),
  expires_at: z.string(),
  request_id: z.string(),
});
export type ApproveResponse = z.infer<typeof approveResponseSchema>;

export const approveInputSchema = z.object({
  decision_reason: z
    .string()
    .trim()
    .min(3, "Document why this request is being approved")
    .max(500),
  ticket_ttl_seconds: z.number().int().min(60).max(3600).optional(),
});
export type ApproveInput = z.infer<typeof approveInputSchema>;

export const denyInputSchema = z.object({
  decision_reason: z
    .string()
    .trim()
    .min(3, "Document why this request is being denied")
    .max(500),
});
export type DenyInput = z.infer<typeof denyInputSchema>;
